var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-container",attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"overlay"},[_c('loading-icon')],1):_c('router-view',{attrs:{"merchant":_vm.merchant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }